import request from './request'

export function getOrderList(params) {
  return request.get('/Order/list', { params })
}

export function getOrderDetail(id) {
  return request.get('/Order/info', { params: { id } })
}

export function selectExpress(data) {
  return request.post('/Order/selectExpress', data)
}

export function selectPickup(data) {
  return request.post('/Order/selectPickup', data)
}

export function updateOrderAddress(data) {
  return request.post('/Order/updateAddress', data)
}

export function getLogistics(id) {
  return request.get('/Order/logistics', { params: { id } })
}

export function getSkuList(orderId) {
  return request.get('/Order/getSkuList', { params: { order_id: orderId } })
}

export function selectSku(data) {
  return request.post('/Order/selectSku', data)
}
